import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import url from "../../function/url";
import DocumentNavbar from "./DocumentNavbar";
import { FaCheck, FaTimes, FaArrowRight } from "react-icons/fa";
import "../JobkitCompany/Modal.css";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";

const TelecallerCertificateRequests = () => {
  const [assignedRequests, setAssignedRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;
    
  const [requests, setRequests] = useState([]);

  const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });
  

  // Fetch assigned blacklist requests for the logged-in telecaller
  useEffect(() => {
    const logId = Cookies.get("log_id"); // Get telecaller ID from the cookie

    if (!logId) {
      setError("User not logged in or session expired. Please log in again.");
      setLoading(false);
      return;
    }

    console.log("Log ID:", logId);

    axios
      .get(`${url.path}/document-telecaller-dashboard/`, {
        params: { log_id: logId },
        // withCredentials: true,
        headers: {
          "X-CSRFToken": Cookies.get("csrftoken"),
        },
      })
      .then((response) => {
        setAssignedRequests(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching requests:", error);
        setError("Failed to fetch assigned requests.");
        setLoading(false);
      });
  }, []);

  // Handle approval of a blacklist request
  const handleApprove = (request) => {
    axios
      .post(`${url.path}/document-telecaller-approve/`, {
        request_id: request.id,
      })
      .then(() => {
        Toast.fire({
          icon: "success",
          title: "Request Approved!",
        });
        
        // Update the state to reflect the approval immediately
        setAssignedRequests((prevRequests) =>
          prevRequests.map((r) =>
            r.id === request.id ? { ...r, approval_status: "Approved" } : r
          )
        );
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error approving request",
        });
        
        console.error("Approval failed:", error);
      });
  };

  // Handle rejection with a reason
  const handleRejection = () => {
    if (!rejectionReason) {
      Toast.fire({
        icon: "warning",
        title: "Please provide a reason for rejection.",
      });
     
      return;
    }

    axios
      .post(`${url.path}/document-telecaller-reject/`, {
        request_id: selectedRequest.id,
        reason: rejectionReason,
      })
      .then(() => {
        Toast.fire({
          icon: "success",
          title: "Request Rejected.",
        });
        
        
        // Update the state to reflect the rejection immediately
        setAssignedRequests((prevRequests) =>
          prevRequests.map((r) =>
            r.id === selectedRequest.id ? { ...r, approval_status: "Rejected" } : r
          )
        );
        setIsRejectionModalOpen(false); // Close modal
        setRejectionReason(""); // Reset rejection reason
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: "Error rejecting request.",
        });
       
        console.error("Rejection failed:", error);
      });
  };


  const handleSearch = (event) => {
    const searchTerm = event.target.value.trim().toLowerCase();
    const rows = document.querySelectorAll("#documentTable tbody tr");

    rows.forEach((row) => {
      const rowText = row.textContent.toLowerCase();
      row.style.display = rowText.includes(searchTerm) ? "" : "none";
    });
  };

  const offset = currentPage * itemsPerPage;
  const currentItems = requests.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(requests.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };


  if (loading) {
    return <p>Loading requests...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <div>
      <DocumentNavbar />
      <center>
      <h3 style={{ fontSize: "20px", position: "relative", top: "10px" }}>Assigned Certificate Requests</h3>
      </center>

      <div className="page-wrapper">
        <div className="input-width">
        <input
          type="text"
          id="search"
          placeholder="Search in table..."
          onInput={handleSearch} // Attach the JavaScript-based search function
          className="search-input"
        />
        </div>
      
      </div>
      <div className="table-container">
      
        <table className="responsive-table" id="documentTable">
          <thead>
            <tr>
              <th>Employee Name</th>
              <th>Certificate</th>
              <th>Issuer</th>
              <th>Certificate File</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {assignedRequests.length > 0 ? (
              assignedRequests.map((request) => (
                <tr key={request.id}>
                  <td>{request.Employee_Name}</td>
                  <td>{request.certificate_type}</td>
                  <td>{request.issuer}</td>
                  <td>
                    {request.certificate_file ? (
                      <a
                        href={`${url.path}${request.certificate_file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Open File
                      </a>
                    ) : (
                      "No File"
                    )}
                  </td>
                  <td>{request.approval_status || "Pending"}</td>
                  <td style={{ display: "flex", gap: "10px", justifyContent: "center", alignItems: "center" }}>
                    <button
                      onClick={() => handleApprove(request)}
                      disabled={
                        request.approval_status === "Approved" ||
                        request.approval_status === "Rejected"
                      }
                    style={{
                          backgroundColor:
                            request.approval_status === "Approved" ||
                            request.approval_status === "Rejected"
                              ? "#ccc"
                              : "#28a745",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          padding: "5px 10px",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          cursor:
                            request.approval_status === "Approved" ||
                            request.approval_status === "Rejected" 
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                         <FaCheck /> Approve
                      {/* {request.approval_status === "Approved"
                        ? "Approved"
                        : "Approve"} */}
                    </button>
                    <button
                      onClick={() => {
                        setSelectedRequest(request);
                        setIsRejectionModalOpen(true);
                      }}
                      disabled={
                        request.approval_status === "Approved" ||
                        request.approval_status === "Rejected"
                      }
                     style={{
                          backgroundColor:
                            request.approval_status === "Approved" ||
                            request.approval_status === "Rejected"
                              ? "#ccc"
                              : "#dc3545",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          padding: "5px 10px",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          cursor:
                            request.approval_status === "Approved" ||
                            request.approval_status === "Rejected"
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <FaTimes />Reject
                      {/* {request.approval_status === "Rejected"
                        ? "Rejected"
                        : "Reject"} */}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No assigned requests found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {requests.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}


      {/* Rejection Reason Modal */}
      {isRejectionModalOpen && (
        <div className="employee-modal-overlay">
          <div className="employee-modal">
          <h3 className="employee-modal-title"> Provide Reason for Rejection</h3>
          <textarea
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            placeholder="Enter reason here"
            className="employee-input"
          ></textarea>
          <div className="employee-buttonContainer">
          <button onClick={handleRejection} className=" employee-modal-btn  employee-primaryButton">Submit</button>
          <button onClick={() => setIsRejectionModalOpen(false)} className="employee-modal-btn  employee-secondaryButton">Cancel</button>
          </div>

          </div>

        </div>
      )}
    </div>
  );
};

export default TelecallerCertificateRequests;
